export const darkTheme = {
    bg:"#f0ead2", 
    bgLight: "#f2edd9",
    primary:"#606c38", // looping text color
    text_primary:"#2d331a", // text
    text_secondary:"#3c4323",
    card:"#f9f2ec", //card color for tools and technologies and projects. okay
    card_light: '#F8EDEB',
    button:"#778745",
    white:"#D4A373",
    black:"#000000",
}
export const lightTheme = {
    bg:"#FFFFFF",
    bgLight: "#f0f0f0",
    primary:"#be1adb",
    text_primary:"#111111",
    text_secondary:"#48494a",
    card:"#FFFFFF",
    button:"#5c5b5b",
}